import { useRouter } from 'expo-router';
import { useTranslation } from 'react-i18next';
import { useMemo } from 'react';
import { Modal, Pressable, StyleSheet, Text, View } from 'react-native';

import { fontSize, radius, spacing } from '@/constants/theme';
import type { AppColors } from '@/constants/theme';
import { useTheme } from '@/contexts/ThemeContext';

type Props = {
  visible: boolean;
  onClose: () => void;
};

/** Υπενθύμιση σε ενεργό επαγγελματικό λογαριασμό χωρίς δηλωμένο επάγγελμα —
 * χωρίς αυτό, ο χρήστης δεν εμφανίζεται σωστά στην αναζήτηση/matching. */
export function ProfessionReminderModal({ visible, onClose }: Props) {
  const { t } = useTranslation();
  const { colors } = useTheme();
  const router = useRouter();
  const styles = useMemo(() => makeStyles(colors), [colors]);

  function handleSetNow() {
    onClose();
    router.push('/(app)/professional-account' as any);
  }

  return (
    <Modal visible={visible} transparent animationType="fade" statusBarTranslucent onRequestClose={onClose}>
      <View style={styles.backdrop}>
        <View style={styles.card}>
          <Text style={styles.emoji}>🧰</Text>
          <Text style={styles.title}>{t('professionReminderModal.title')}</Text>
          <Text style={styles.body}>{t('professionReminderModal.body')}</Text>
          <Pressable style={[styles.btn, { backgroundColor: colors.primary }]} onPress={handleSetNow}>
            <Text style={styles.btnText}>{t('professionReminderModal.action')}</Text>
          </Pressable>
          <Pressable style={styles.laterBtn} onPress={onClose}>
            <Text style={styles.laterText}>{t('common.maybeLater')}</Text>
          </Pressable>
        </View>
      </View>
    </Modal>
  );
}

function makeStyles(colors: AppColors) {
  return StyleSheet.create({
    backdrop: {
      flex: 1,
      backgroundColor: 'rgba(0,0,0,0.6)',
      alignItems: 'center',
      justifyContent: 'center',
      padding: spacing.xl,
    },
    card: {
      backgroundColor: colors.surface,
      borderRadius: radius.xl,
      padding: spacing.xl,
      alignItems: 'center',
      gap: spacing.sm,
      width: '100%',
      maxWidth: 320,
    },
    emoji: { fontSize: 48 },
    title: {
      color: colors.text,
      fontSize: fontSize.xl,
      fontWeight: '700',
      textAlign: 'center',
    },
    body: {
      color: colors.textMuted,
      fontSize: fontSize.md,
      textAlign: 'center',
      lineHeight: 22,
      marginBottom: spacing.xs,
    },
    btn: {
      width: '100%',
      borderRadius: radius.md,
      paddingVertical: spacing.md,
      alignItems: 'center',
    },
    btnText: {
      color: '#fff',
      fontSize: fontSize.md,
      fontWeight: '700',
    },
    laterBtn: { paddingVertical: spacing.sm },
    laterText: {
      color: colors.textMuted,
      fontSize: fontSize.sm,
    },
  });
}
